export class ListarEncaminhados{
  codigoPolo:number;
  codigoDiretoria:number;
  codigoEscola:number | undefined;
  dataInicial:Date;
  dataFinal:Date;
  codigoSubCategoria:number;
  perfil:number;
}
